// extracted by mini-css-extract-plugin
module.exports = {"cursor":"navigationdropdown_cursor__29FI1","badgeCount":"navigationdropdown_badgeCount__BIypy","desktopTabs":"navigationdropdown_desktopTabs__1drxG"};